import { toTravelersPayload } from "./travelers";

// Mirrors the create/update request schema, which POST and PUT share. The edit form is seeded from a
// GET response, so spreading it would also send back id, the *Text echoes, staffRequest and locations[].id.
export const toBusinessTripPayload = data => ({
  businessTripType: data.businessTripType,
  domesticTripCategory: data.domesticTripCategory ?? null,
  transportType: data.transportType,
  vehicleTypeAndMake: data.vehicleTypeAndMake ?? null,
  fuelType: data.fuelType ?? null,
  averageFuelConsumption: data.averageFuelConsumption ?? null,
  fuelPrice: data.fuelPrice ?? null,
  distanceInKm: data.distanceInKm ?? null,
  dateFrom: data.dateFrom,
  dateTo: data.dateTo,
  travelers: toTravelersPayload(data.travelers),
  locations: (data.locations ?? []).map(({ countryId, settlementId, settlement }) => ({
    countryId: countryId ?? null,
    settlementId: settlementId ?? null,
    settlement: settlement ?? null,
  })),
  route: data.route,
  mealProvided: data.mealProvided,
  dailyAllowancePerDay: data.dailyAllowancePerDay,
  dailyAllowanceDays: data.dailyAllowanceDays,
  maxAccommodationAmountPerNight: data.maxAccommodationAmountPerNight,
  nightsCount: data.nightsCount,
  expensePayer: data.expensePayer,
  assignment: data.assignment,
});
